import * as lodash from '../utils/lodash';
import interpolateNumber from './interpolateNumber';
import interpolateArray from './interpolateArray';
import interpolateObject from './interpolateObject';
import interpolateColor from './interpolateColor';
import interpolatePath from './interpolatePath';
export { interpolateNumber, interpolateArray, interpolateObject, interpolatePath, interpolateColor, interpolate, };
function interpolate(from, to, k) {
    if (typeof from === 'number' && typeof to === 'number') {
        return interpolateNumber(from, to, k);
    }
    if (Array.isArray(from) && Array.isArray(to)) {
        return interpolateArray(from, to, k);
    }
    if (lodash.isObject(from) && lodash.isObject(to)) {
        return interpolateObject(from, to, k);
    }
    return to;
}
